import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class LoggingAndStatusIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          fillRule='evenodd'
          d="M-0.000,11.994 L-0.000,-0.000 L16.014,-0.000 L16.014,11.994 L-0.000,11.994 ZM8.009,2.992 L2.014,2.992 L2.014,5.003 L8.009,5.003 L8.009,2.992 ZM8.009,6.992 L2.014,6.992 L2.014,9.003 L8.009,9.003 L8.009,6.992 ZM13.855,2.165 C13.634,1.944 13.276,1.944 13.056,2.165 L11.444,4.607 L10.930,4.126 C10.710,3.905 10.352,3.905 10.131,4.126 C9.911,4.346 9.911,4.704 10.131,4.925 L11.144,5.875 C11.365,6.096 11.723,6.096 11.943,5.875 C11.959,5.859 11.954,5.835 11.967,5.817 C11.969,5.815 11.972,5.815 11.974,5.813 L13.855,2.964 C14.075,2.743 14.075,2.385 13.855,2.165 ZM13.855,6.165 C13.634,5.944 13.276,5.944 13.056,6.165 L11.444,8.607 L10.930,8.126 C10.710,7.905 10.352,7.905 10.131,8.126 C9.911,8.346 9.911,8.704 10.131,8.925 L11.144,9.875 C11.365,10.096 11.723,10.096 11.943,9.875 C11.959,9.859 11.954,9.835 11.967,9.817 C11.969,9.815 11.972,9.815 11.974,9.813 L13.855,6.964 C14.075,6.743 14.075,6.385 13.855,6.165 Z"
          transform="translate(0 2)"/>
  ]
  getViewBox = () => '0 0 16 16'
}


